import './offline-ribbon.scss';

import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const OfflineRibbon = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./offline-ribbon.html'),
    data() {
        return {
            onLine: true,
            running: false,
        }
    },
    created() {
        this.running = true;
        this.onFrame();
    },
    beforeUnmount() {
        this.running = false;
    },
    methods: {
        onFrame() {
            this.onLine = window.navigator.onLine;

            if (this.running) {
                requestAnimationFrame(this.onFrame);
            }
        },
        checkOnLine() {
            this.onLine = window.navigator.onLine;
        },
    },
})
